// NOTE: hooks
import { useState } from 'react'
import useDataRegister from './useDataRegister'
// NOTE: components
import { PasswordInfo, BiologicalSexInfo, PersonaGoalInfo } from './InputInfo'
import { BiShow, BiHide } from 'react-icons/bi'
import { Tooltip } from 'react-tooltip'
import DateInput from '../../components/ui/DateInput'
import Button from '../../components/ui/Button'
// NOTE: images
import { TbAlertCircle as AlertIcon } from 'react-icons/tb'
import { IoMdHelpCircleOutline } from 'react-icons/io'
// NOTE: pdfs
import PrivacyPolicy from '../../assets/terms/PrivacyPolicy.pdf'
import TermsConditions from '../../assets/terms/TermsConditions.pdf'

const Register = () => {
	const {
		loading,
		values,
		errors,
		touched,
		handleChange,
		handleSubmit,
		handleBlur,
		setFieldValue
	} = useDataRegister()

	const [seePassShow, setSeePassShow] = useState(false)
	const [seePassConfShow, setSeePassConfShow] = useState(false)
	const [sexShow, setSexShow] = useState(false)
	const [personaShow, setPersonaShow] = useState(false)
	const [passShow, setPassShow] = useState(false)

	return (
		<div>
			<BiologicalSexInfo show={sexShow} setShow={setSexShow} />

			<PersonaGoalInfo show={personaShow} setShow={setPersonaShow} />

			<PasswordInfo show={passShow} setShow={setPassShow} />

			<div>
				<p className="text-dark mb-6 text-3xl font-semibold">Register</p>

				<form onSubmit={handleSubmit}>
					<div className="form-group mb-4">
						<label>Enter email</label>
						<input
							type="email"
							name="email"
							className={`form-control ${errors.email && touched.email ? 'input-error' : null}`}
							placeholder="Email"
							onChange={handleChange}
							value={values.email}
							onBlur={handleBlur}
							required
						/>
						<div className="mt-2 flex items-center text-sm text-red-600" role="alert">
							{errors.email && touched.email && (
								<AlertIcon className="flex-shrink-1 me-1 inline h-4 w-4" />
							)}
							{errors.email && touched.email && (
								<div className="text-sm text-red-600" role="alert">
									<span className="font-medium">{errors.email}</span>
								</div>
							)}
						</div>
					</div>

					<div className="flex flex-wrap justify-between">
						<div className="form-group mb-4 w-full p-0 md:w-1/2 md:pr-2">
							<label>Enter forename</label>
							<input
								className={`form-control ${errors.fname && touched.fname ? 'input-error' : null}`}
								type="text"
								name="fname"
								placeholder="Forename"
								onChange={handleChange}
								value={values.fname}
								onBlur={handleBlur}
								required
							/>
							<div className="mt-2 flex items-center text-sm text-red-600" role="alert">
								{errors.fname && touched.fname && (
									<AlertIcon className="flex-shrink-1 me-1 inline h-4 w-4" />
								)}
								{errors.fname && touched.fname && (
									<div className="text-sm text-red-600" role="alert">
										<span className="font-medium">{errors.fname}</span>
									</div>
								)}
							</div>
						</div>

						<div className="form-group mb-4 w-full p-0 md:w-1/2 md:pl-2">
							<label>Enter surname</label>
							<input
								className={`form-control ${errors.lname && touched.lname ? 'input-error' : null}`}
								type="text"
								name="lname"
								placeholder="Surname"
								onChange={handleChange}
								onBlur={handleBlur}
								value={values.lname}
								required
							/>
							<div className="mt-2 flex items-center text-sm text-red-600" role="alert">
								{errors.lname && touched.lname && (
									<AlertIcon className="flex-shrink-1 me-1 inline h-4 w-4" />
								)}
								{errors.lname && touched.lname && (
									<div className="text-sm text-red-600" role="alert">
										<span className="font-medium">{errors.lname}</span>
									</div>
								)}
							</div>
						</div>
					</div>

					<div className="form-group mb-4">
						<label>Enter birthday</label>
						<DateInput
							name="dob"
							value={values.dob}
							onChange={(date: any) => setFieldValue('dob', date)}
							onBlur={handleBlur('dob')}
						/>

						<div className="mt-2 flex items-center text-sm text-red-600" role="alert">
							{errors.dob && touched.dob && (
								<AlertIcon className="flex-shrink-1 me-1 inline h-4 w-4" />
							)}
							{errors.dob && touched.dob && (
								<div className="text-sm text-red-600" role="alert">
									<span className="font-medium">{errors.dob}</span>
								</div>
							)}
						</div>
					</div>

					<div className="form-group mb-4">
						<div className="mt-2 flex items-center" role="alert">
							<label>Biological sex</label>
							<span
								onClick={() => setSexShow(true)}
								data-tooltip-id="sex-tooltip"
								data-tooltip-content="Click for more information"
								data-tooltip-place="top"
							>
								<IoMdHelpCircleOutline className="flex-shrink-1 mb-2 ml-1 inline h-4 w-4" />
								<Tooltip id="sex-tooltip" />
							</span>
						</div>
						<select
							className={`form-control ${
								errors.biologicalSex && touched.biologicalSex ? 'input-error' : null
							}`}
							name="biologicalSex"
							value={values.biologicalSex}
							onChange={handleChange}
							onBlur={handleBlur}
							required
						>
							<option hidden value="">
								Choose biological sex
							</option>
							<option value="248152002">Female</option>
							<option value="248153007">Male</option>
							<option value="32570691000036108">Intersex</option>
						</select>

						<div className="mt-2 flex items-center text-sm text-red-600" role="alert">
							{errors.biologicalSex && touched.biologicalSex && (
								<AlertIcon className="flex-shrink-1 me-1 inline h-4 w-4" />
							)}
							{errors.biologicalSex && touched.biologicalSex && (
								<div className="text-sm text-red-600" role="alert">
									<span className="font-medium">{errors.biologicalSex}</span>
								</div>
							)}
						</div>
					</div>

					<div className="form-group mb-4">
						<div className="mt-2 flex items-center" role="alert">
							<label>Wellbeing goal</label>
							<span
								onClick={() => setPersonaShow(true)}
								data-tooltip-id="sex-tooltip"
								data-tooltip-content="Click for more information"
								data-tooltip-place="top"
							>
								<IoMdHelpCircleOutline className="flex-shrink-1 mb-2 ml-1 inline h-4 w-4" />
								<Tooltip id="sex-tooltip" />
							</span>
						</div>
						<select
							className={`form-control ${errors.persona && touched.persona ? 'input-error' : null}`}
							name="persona"
							value={values.persona}
							onChange={handleChange}
							onBlur={handleBlur}
							required
						>
							<option hidden value="">
								Choose your wellbeing goal
							</option>
							<option value="Longer">Live Longer - I want to make sure I’m healthy</option>
							<option value="Sharper">Live Sharper - I want to improve mental performance</option>
							<option value="Stronger">Live Stronger - I want to push my body</option>
						</select>

						<div className="mt-2 flex items-center text-sm text-red-600" role="alert">
							{errors.persona && touched.persona && (
								<AlertIcon className="flex-shrink-1 me-1 inline h-4 w-4" />
							)}
							{errors.persona && touched.persona && (
								<div className="text-sm text-red-600" role="alert">
									<span className="font-medium">{errors.persona}</span>
								</div>
							)}
						</div>
					</div>

					<div className="form-group mb-4" role="alert">
						<label>Enter password</label>
						<span
							onClick={() => setPassShow(true)}
							data-tooltip-id="password-tooltip"
							data-tooltip-content="Click for more information"
							data-tooltip-place="top"
						>
							<IoMdHelpCircleOutline className="flex-shrink-1 mb-2 ml-1 inline h-4 w-4" />
							<Tooltip id="password-tooltip" />
						</span>
						<div className="relative">
							<input
								type={seePassShow ? 'text' : 'password'}
								className={`form-control ${
									errors.password && touched.password ? 'input-error' : null
								}`}
								placeholder="Password"
								name="password"
								value={values.password}
								onChange={handleChange}
								onBlur={handleBlur}
							/>

							<button
								type="button"
								className="absolute right-[8px] top-[7px] text-2xl"
								onClick={() => setSeePassShow((show) => !show)}
							>
								{seePassShow ? <BiShow /> : <BiHide />}
							</button>
						</div>
						<div className="mt-2 flex items-center text-sm text-red-600" role="alert">
							{errors.password && touched.password && (
								<AlertIcon className="flex-shrink-1 me-1 inline h-4 w-4" />
							)}
							{errors.password && touched.password && (
								<div className="text-sm text-red-600" role="alert">
									<span className="font-medium">{errors.password}</span>
								</div>
							)}
						</div>
					</div>

					<div className="form-group mb-6">
						<label>Confirm password</label>
						<div className="relative">
							<input
								type={seePassConfShow ? 'text' : 'password'}
								className={`form-control ${
									errors.confirmPwd && touched.confirmPwd ? 'input-error' : null
								}`}
								placeholder="Password"
								name="confirmPwd"
								value={values.confirmPwd}
								onChange={handleChange}
								onBlur={handleBlur}
							/>

							<button
								type="button"
								className="absolute right-[8px] top-[7px] text-2xl"
								onClick={() => setSeePassConfShow((show) => !show)}
							>
								{seePassConfShow ? <BiShow /> : <BiHide />}
							</button>
						</div>
						<div className="mt-2 flex items-center text-sm text-red-600" role="alert">
							{errors.confirmPwd && touched.confirmPwd && (
								<AlertIcon className="flex-shrink-1 me-1 inline h-4 w-4" />
							)}
							{errors.confirmPwd && touched.confirmPwd && (
								<div className="text-sm text-red-600" role="alert">
									<span className="font-medium">{errors.confirmPwd}</span>
								</div>
							)}
						</div>
					</div>

					<div className="mb-6">
						<label>
							<input className="mr-2 accent-orange-700" type="checkbox" required />
							{'Accept '}
							<a
								href={PrivacyPolicy}
								className="text-dark font-semibold underline"
								target="_blank"
								rel="noopener noreferrer"
							>
								privacy policy
							</a>
							{' and '}
							<a
								href={TermsConditions}
								className="text-dark font-semibold underline"
								target="_blank"
								rel="noopener noreferrer"
							>
								terms
							</a>
						</label>
					</div>

					<Button type="submit" variant="primary" className="w-full" loading={loading}>
						Create account
					</Button>
				</form>
			</div>
		</div>
	)
}

export default Register
